<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EjOMBQ/tc-custom/9780253013033.jpg?1726871162592" alt="This image is the cover for the book Light Traces, Studies in Continental Thought"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Light Traces, Studies in Continental Thought
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection of philosophical essays on place and nature, featuring beautiful paintings and drawings.</b><br/><br/>What is the effect of light as it measures the seasons? How does light leave different traces on the terrain—on a Pacific Island, in the Aegean Sea, high in the Alps, or in the forest? John Sallis considers the expansiveness of nature and the range of human vision in essays about the effect of light and luminosity on place. Sallis writes movingly of nature and the elements, employing an enormous range of philosophical, geographical, and historical knowledge. Paintings and drawings by Alejandro A. Vallega illuminate the text, accentuating the interaction between light and environment.<br/><br/><b>“A profound and exceptionally nuanced piece of writing that brings philosophy and art into close proximity. Decades of Sallis’s remarkable philosophical thinking are at work and play.” —Jason M. Wirth, Seattle University</b><br/><br/><b>“Beautifully conceived and written. Sallis engages the elemental interplay of earth and sky, translucence and obscurity, airiness and density, height and depth, wet and dry, gods and mortals, storms and clouds, rivers and fog, plains and mountains–nature in its expansive, indefinable materiality and ephemeral intangibility.” —Charles E. Scott, Vanderbilt University</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Sallis, Alejandro A. Vallega
      </h2>
      
      <p class="authorDescription body article"><P>John Sallis is Frederick J. Adelmann Professor of Philosophy at Boston College. He is author of Logic of Imagination: The Expanse of the Elemental (IUP, 2012) and Topographies (IUP, 2006). </P><P>Alejandro A. Vallega is Associate Professor of Philosophy at the University of Oregon. He trained as a visual artist before studying philosophy. He is author of Latin American Philosophy from Identity to Radical Exteriority (IUP, 2014).</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?66230f06